<template>
    <Card>
        <p slot="title">
            <Icon type="md-alert" />
            门店配额
        </p>
        <template slot="extra">
             <Button type="primary"
              icon="md-download"
              @click="downloadFile()">下载模板</Button>
            <Button type="primary" icon="md-add" @click="uploadToggle()">导入</Button>
        </template>
        <Row>
            <Col span="24">
                <Input v-model="query.brandCode" placeholder="请输入品牌" class="public-inp md5"/>
                <Input v-model="query.platformCode" placeholder="请输入平台" class="public-inp md5"/>
                <span class="public-stretch" @click="open = !open">
                <Icon :type="open?'ios-arrow-up':'ios-arrow-down'" />{{open?'收起':'展开'}}
                </span>
                <span v-if="open">
                    <br />
                    <Input v-model="query.retailerCode" placeholder="请输入门店" class="public-inp md5"/>
                    <Input v-model="query.spuCode" placeholder="请输入SPU" class="public-inp md5"/>
                    <Input v-model="query.skuCode" placeholder="请输入SKU" class="public-inp md5"/>
                    <br />
                    <Select v-model="query.status" placeholder="请选择状态" class="public-inp">
                        <Option value="" >全部</Option>
                        <Option value="0" >生效</Option>
                        <Option value="1" >停用</Option>
                    </Select>
                    <DatePicker 
                    type="month" 
                    placeholder="请选择配额月份" 
                    v-model="query.yearMonth"
                    format="yyyyMM"
                    class="public-inp"
                    ></DatePicker>
                </span>
                <Button class="public-fr" @click="reset()" v-access="'allocRetailer.reset'">重置</Button>
                <Button class="public-fr" type="primary" icon="ios-search" @click="getList()" v-access="'allocRetailer.query'">查询</Button>
            </Col>
            <Col span="24">
                <Table
                    :style="{marginTop:'10px'}"
                    border
                    stripe
                    :loading="loading"
                    :columns="columns"
                    :data="tbList">
                    <template slot-scope="{ row,index }" slot="sort">
                        <span v-show="false">{{row.code}}</span>
                {{(page-1)*pageSize+index+1}}
                    </template>
                </Table>
                <Page 
                :total="total" 
                :page-size="pageSize"
                :current="page"
                show-sizer 
                show-total 
                prev-text="上一页" 
                next-text="下一页" 
                @on-change="pageNumChange"
                @on-page-size-change="pageSizeChange"
                class="public-page"
                />
            </Col>
        </Row>
        <allocImport 
        :visiable = 'visiable' 
        templateFileType = 'ALLOC_RETAILER_TEMPLATE'
        @uploadToggle="uploadToggle"
        @reloadList="getList"
        ></allocImport>
    </Card>
</template>
<script>
import columns from '@/views/quota/columns';
import allocImport from '@/views/quota/allocImport';
    export default {
        components:{
            allocImport
        },
        data () {
            return {
                visiable:false,
                open:false,
                query:{
                    brandCode:'',
                    platformCode:'',
                    skuCode:'',
                    spuCode:'',
                    status:'',
                    yearMonth:'',
                    retailerCode:'',
                },
                page:1,
                pageSize:10,
                total:0,
                columns:columns.retailer,
                tbList:[],
                loading:false,
                templatePath:'https://eln-public.oss-cn-shanghai.aliyuncs.com/dev/ee74ca70-7a62-45e7-849c-751c9dab8d00.xlsx',
            }
        },
        created(){
            this.getList();
        },
        methods: {
            downloadFile(){
                let url = this.templatePath;
                try {
                    var elemIF = document.createElement("iframe");
                    elemIF.src = url;
                    elemIF.style.display = "none";
                    document.body.appendChild(elemIF);
                    } catch (e) {
                        this.$Message.error('下载异常！');
                    }
            },
            getList(){
                let data = this.query;
                data.yearMonth = this.tools.yyyymm(data.yearMonth);
                data.page = this.page;
                data.pageSize = this.pageSize;
                this.loading = true;
                this.$api.allocRetailer(data).then(res=>{
                    this.loading = false;
                    if(res.code=='200'){
                        this.tbList = res.data;
                        this.total = res.total;
                    }
                })
            },
            reset(){
                Object.keys(this.query).forEach(i=>{
                    this.query[i] = '';
                });
                this.page=1;
                this.pageSize=10;
                this.$nextTick(()=>{
                    this.getList();
                })
            },
            uploadToggle(){
                this.visiable = !this.visiable;
            },
            // 页码
            pageNumChange(d){
                this.page = d;
                this.getList();
            },
            // 页数
            pageSizeChange(d){
                this.pageSize = d;
                this.getList();
            },
        }
    }
</script>
<style scoped>
    .md5 {
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/views/quota/allocRetailer.vue